/**
 * Genera una URL absoluta para una imagen o recurso.
 * Maneja automáticamente las diferencias entre el entorno de desarrollo y producción.
 */
export const getImageUrl = (path: string | undefined | null): string => {
    if (!path) return '';

    // Si la URL ya es absoluta, la retornamos tal cual (el symlink se encarga del resto)
    if (path.startsWith('http')) {
        return path;
    }

    // Obtener la URL base desde las variables de entorno
    let baseUrl = (import.meta.env.VITE_API_URL_ASSETS as string) || '';

    // En producción, Hostinger usa el symlink /api/ que apunta directo a laravel_api/public
    if (import.meta.env.PROD || (typeof window !== 'undefined' && (window.location.hostname.includes('duffigelato.com') || window.location.hostname.includes('blue-snail-706236.hostingersite.com')))) {
        const origin = typeof window !== 'undefined' ? window.location.origin : 'https://duffigelato.com';
        baseUrl = `${origin}/api`;
    } else if (!baseUrl || baseUrl.includes('localhost')) {
        // Fallback para otros entornos o local si no hay VITE_API_URL_ASSETS
        const apiUrl = import.meta.env.VITE_API_URL as string;
        if (apiUrl && !apiUrl.includes('localhost')) {
            baseUrl = apiUrl.split('/api')[0];
        } else {
            baseUrl = typeof window !== 'undefined' ? window.location.origin : '';
        }
    }

    // Si después de todo sigue estando vacío, usamos el origen actual como último recurso
    if (!baseUrl) {
        baseUrl = typeof window !== 'undefined' ? window.location.origin : '';
    }

    // Normalizar: quitar barra final de base y asegurar barra inicial en path
    const cleanBase = baseUrl.replace(/\/$/, '');
    const cleanPath = path.startsWith('/') ? path : `/${path}`;

    return `${cleanBase}${cleanPath}`;
};
